import {
  serializable,
  alias,
  list,
  object,
  primitive,
  custom,
  deserialize,
} from 'serializr';
import { ScopeMonthlyData } from './scopes.model';

const serializeScopeMonthlyData = (
  value: ScopeMonthlyData[] | null | undefined
) => {
  if (value == null) return null;
  return value.map(item => ({
    month: item.month,
    value: item.value ?? null,
  }));
};

const deserializeScopeMonthlyData = (json: unknown) => {
  if (json == null || !Array.isArray(json)) return undefined;
  return json.map(item => deserialize(ScopeMonthlyData, item));
};

export class ScopeWasteType {
  @serializable
  id?: number;

  @serializable(alias('treatment_method', primitive()))
  treatmentMethod?: string | null = null;

  @serializable(alias('waste_type_id', primitive()))
  wasteTypeId?: number | null = null;

  @serializable(alias('total_waste_produced', primitive()))
  totalWasteProduced?: number | null = null;

  @serializable(alias('is_yearly', primitive()))
  isYearly?: boolean = true;

  @serializable(
    alias(
      'scope_monthly_data',
      custom(serializeScopeMonthlyData, deserializeScopeMonthlyData)
    )
  )
  scopeMonthlyData?: ScopeMonthlyData[] | null;
}

export class ScopeThreeData {
  @serializable(alias('products_total_weight', primitive()))
  productsTotalWeight?: number;

  @serializable(alias('total_waste_water', primitive()))
  totalWasteWater?: number;

  @serializable(alias('total_waste_produced', primitive()))
  totalWasteProduced?: number;

  @serializable(alias('waste_diversion_rate', primitive()))
  wasteDiversionRate?: number | null;

  @serializable(alias('scope_waste_type', list(object(ScopeWasteType))))
  scopeWasteType?: ScopeWasteType[];
}
